import React, { Component } from "react";
import { Service } from "../../../service/service";
import { API } from "../../../../const";
export default class PrivatePostKidsItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      kidURI: "",
    };
  }

  componentWillMount() {
    let tok = localStorage.getItem("token");
    var kidsId = this.props.kid.id;
    const response = Service.get(`${API}api/enfant/creche/enfants/${kidsId}`, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {
      this.setState({
        kidURI: res.data.lienPhoto,
      });
    });
    response.catch((err) => {});
  }

  render() {
    return (
      <li className="col-md-6 px-2">
        <input type="checkbox" />
        <label
          className="rounded15 box-shadow"
          htmlFor={`${this.props.kid.id}`}
        >
          <span
            className="avatar"
            style={{
              color: "white",
              backgroundImage:
                this.state.kidURI !== ""
                  ? "url(" + this.state.kidURI + ")"
                  : "",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
              backgroundSize: "cover",
              position: "relative",
              width: "65px",
              minHeight: "55px",
            }}
          />
          {this.props.kid.nom === undefined ? (
            <span className="name"></span>
          ) : (
            <span className="name">
              {this.props.kid.nom + " " + this.props.kid.prenom}.
            </span>
          )}
        </label>
      </li>
    );
  }
}
